import { Expose } from "class-transformer";
import { ProductWithCmsDataDto } from "../product-with-cms-data/product-with-cms-data.dto";
import { IProductWithCmsDataAndQualificationDto } from "./product-with-cms-data-and-qualification.dto.interface";

export class ProductWithCmsDataAndQualificationDto
  extends ProductWithCmsDataDto
  implements IProductWithCmsDataAndQualificationDto
{
  @Expose()
  available!: boolean;
  @Expose()
  discountedPrice!: number;
  @Expose()
  appliedDiscountCode!: string;
  @Expose()
  isRequestable!: boolean;
  @Expose()
  isVisible!: boolean;
  @Expose()
  activeProcedureIdsByDescCreationOrder!: number[];
  @Expose()
  orderedTiersThatCanRequestProduct: string[] | undefined;
}
